/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import * as React from 'react'
import toast from 'cogo-toast'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie'
import { Card, Grid, Form, Button } from 'tabler-react'
import store from '../../shared/store'

import Request from '../../shared/request'
import PageComponent from '../PageComponent'
import './account.scss'

class AccountBindEmail extends PageComponent {
  state = {
    isProcessing: false,
    clock: 60,
    loading: false,
    captcha: '',
    captchaValue: '',
    captchaToken: '',
    tab: 'email',
    areacode: '86',
  };

  componentDidMount() {
    const search = new URLSearchParams(window.location.search)
    const tabValue = search.get('tab') || search.get('tab') || 'email'
    this.setState({
      tab: tabValue,
    })
  }

  handleSubmit = event => {
    event.preventDefault()
    const { email } = store.user
    const { confirmPassword, newPassword, password } = this.state
    this.resetPassword({ confirmPassword, newPassword, password, email })
  };

  handleSendPasscode = async event => {
    event.preventDefault()
    if (!this.state.email && !this.state.phone) {
      return toast.warn('请输入邮箱或者手机号')
    }
    if (this.state.isProcessing) {
      return toast.warn('请稍后发送')
    }
    this.setState({ captcha: '' })
    this.setState({ isProcessing: true, clock: 60 })
    const body = {
      type: this.state.tab,
    }
    if (this.state.tab === 'email') {
      body.email = this.state.email
      body.from = 'BIND_EMAIL'
    } else {
      body.from = 'BIND_PHONE'
      body.phone = `+${this.state.areacode}${this.state.phone}`
    }
    if (this.state.captchaValue) {
      body.captcha = this.state.captchaValue
      body.captchaToken = this.state.captchaToken
    }
    const res = await Request.call('sendPasscode', body)
    if (res.code === 11138) {
      const { captchaToken, captcha } = res.data
      this.setState({ captcha, captchaToken })
      return this.setState({ isProcessing: false })
    }
    if (res) {
      toast.success('验证码已发送,60S后可重新获取', 3)
      this.timer = setInterval(() => {
        this.setState(prevState => {
          const newState = { clock: prevState.clock - 1 }
          if (prevState.clock <= 1) {
            newState.isProcessing = false
            clearInterval(this.timer)
          }
          return newState
        })
      }, 1000)
    } else {
      this.setState({ isProcessing: false })
    }
  };

  handleBindEmail = async event => {
    event.preventDefault()
    if (this.state.loading) {
      return
    }
    if (!this.state.password) {
      toast.warn('密码不能为空')
      return
    }
    this.setState({ loading: true })
    const body = {
      verifyCode: this.state.verifyCode,
      password: this.state.password,
    }
    if (this.state.tab === 'email') {
      body.email = this.state.email
    } else {
      body.phone = `+${this.state.areacode}${this.state.phone}`
    }
    const res = await Request.call('bindAccount', body)
    this.setState({ loading: false })
    if (res && res.email) {
      this.saveToken(res)
      toast.success(`${res.email} 邮箱绑定成功`)
      window.location.href = '/dashboard/account'
    }
  };

  saveToken = userInfo => {
    if (userInfo) {
      localStorage.setItem('login', JSON.stringify(userInfo))
      Cookies.set('malus-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      })
    }
  };

  render() {
    return (
      <Grid.Row className="malus-setting">
        <Grid.Col>
          <Card>
            <Card.Header>
              <Link to="/dashboard/account">
                <i className="fa fa-angle-left" />
                账号设置
              </Link>
              <Card.Title>账号绑定</Card.Title>
            </Card.Header>
            <Form onSubmit={this.handleSubmit}>
              {/* <div className="tips">
                * 支持绑定已存的帐号，密码以本次设置为准，VIP时长将合并
              </div> */}
              {this.state.captcha ? (
                <div className="captcha">
                  <div className="content">
                    <div className="header">
                      <div className="title">安全验证</div>
                      <i
                        className="ri-close-circle-line"
                        onClick={() => this.setState({ captcha: null })}
                      />
                    </div>
                    <div className="body">
                      <img
                        src={`data:image/png;base64,${this.state.captcha}`}
                        onClick={this.handleSendPasscode}
                        alt="code"
                      />
                      <Form.Input
                        onChange={e =>
                          this.setState({ captchaValue: e.target.value })
                        }
                        type="text"
                        autoComplete="off"
                        value={this.state.captchaValue}
                        placeholder="请输入安全码"
                      />
                      <Button
                        className="malus-setting-btn"
                        type="submit"
                        color="primary"
                        onClick={this.handleSendPasscode}>
                        完成验证
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                  ''
                )}
              {/* <div className="bind-tab">
                <h3
                  onClick={e => this.setState({ tab: 'email' })}
                  className={this.state.tab === 'email' ? 'active' : ''}>
                  绑定邮箱
                </h3>
                <h3
                  onClick={e => this.setState({ tab: 'phone' })}
                  className={this.state.tab === 'phone' ? 'active' : ''}>
                  绑定手机
                </h3>
              </div> */}
              {this.state.tab === 'email' ? (
                <Form.Group>
                  <Form.InputGroup>
                    <Form.Input
                      placeholder="输入绑定邮箱"
                      value={this.state.email}
                      onChange={e => this.setState({ email: e.target.value })}
                    />
                    <Form.InputGroupAppend>
                      <Button
                        RootComponent="div"
                        color="primary"
                        disabled={this.state.isProcessing ? 'disanled' : ''}
                        onClick={this.handleSendPasscode}>
                        {this.state.isProcessing
                          ? `${this.state.clock} S`
                          : '发送验证码'}
                      </Button>
                    </Form.InputGroupAppend>
                  </Form.InputGroup>
                </Form.Group>
              ) : (
                  <Form.Group>
                    <Form.InputGroup className="phone-group">
                      <span className="plus">+</span>
                      <Form.Input
                        className="area"
                        placeholder="区号"
                        value={this.state.areacode}
                        onChange={e =>
                          this.setState({ areacode: e.target.value })
                        }
                      />
                      <Form.Input
                        className="number"
                        placeholder="输入绑定手机号"
                        value={this.state.phone}
                        onChange={e => this.setState({ phone: e.target.value })}
                      />
                      <Form.InputGroupAppend>
                        <Button
                          RootComponent="div"
                          color="primary"
                          disabled={this.state.isProcessing ? 'disanled' : ''}
                          onClick={this.handleSendPasscode}>
                          {this.state.isProcessing
                            ? `${this.state.clock} S`
                            : '发送验证码'}
                        </Button>
                      </Form.InputGroupAppend>
                    </Form.InputGroup>
                  </Form.Group>
                )}

              <Form.Input
                onChange={e => this.setState({ verifyCode: e.target.value })}
                type="text"
                autoComplete="off"
                value={this.state.verifyCode}
                placeholder="输入验证码"
              />
              <Form.Input
                onChange={e => this.setState({ password: e.target.value })}
                type="password"
                autoComplete="off"
                value={this.state.password}
                placeholder="输入密码"
              />
              <Button
                className="malus-setting-btn"
                loading={this.state.loading}
                type="submit"
                disabled={this.state.loading ? 'disabled' : ''}
                color="primary"
                onClick={this.handleBindEmail}>
                {this.state.loading ? '正在绑定...' : '立即绑定'}
              </Button>
            </Form>
          </Card>
        </Grid.Col>
      </Grid.Row>
    )
  }
}

export default AccountBindEmail
